import { useState } from 'react';
import { useController, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IconManager } from '@speeki/icons';

import {
    SearchInput,
    SearchWrapper,
    StyledFormWrapper,
    StyledIconSearch,
    StyledIconSearchButton,
} from './CasesSearchForm.styled';

interface CasesSearchForm {
    search: string;
}

interface CasesSearchFormProps {
    setSearchPhrase: (phrase: string) => void;
}

export const CasesSearchForm = ({ setSearchPhrase }: CasesSearchFormProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const { t } = useTranslation();
    const { control, reset } = useForm<CasesSearchForm>();

    const { field } = useController({
        control,
        defaultValue: '',
        name: 'search',
    });

    const onSubmit = () => {
        setSearchPhrase(field.value);
    };

    const onCancel = () => {
        reset();
        setSearchPhrase('');
        setIsOpen(false);
    };

    return (
        <StyledFormWrapper>
            {isOpen ? (
                <SearchWrapper>
                    <StyledIconSearch icon={'SvgSearch'} size={20} />
                    <SearchInput
                        {...field}
                        onReset={onCancel}
                        onSearch={onSubmit}
                        placeholder={t('SEARCH_PLACEHOLDER')}
                        testId="uDjjxeq"
                    />
                </SearchWrapper>
            ) : (
                <StyledIconSearchButton
                    data-testid="pd3tGri"
                    onClick={() => setIsOpen(true)}
                >
                    <IconManager icon={'SvgSearch'} size={20} />
                </StyledIconSearchButton>
            )}
        </StyledFormWrapper>
    );
};
